(() => {
  const track = (event, data = {}) => {
    const payload = { event, ...data };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('npc:analytics', { detail: payload }));
  };

  window.NPCTrack = track;


  class NpcUnitPrice extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-npc-unit-price]');
      this.note = this.querySelector('[data-npc-unit-price-note]');
      const data = this.querySelector('[data-npc-unit-price-variants]');
      try {
        this.variants = JSON.parse(data?.textContent || '[]');
      } catch (_) {
        this.variants = [];
      }
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.form = document.getElementById(this.dataset.formId || '');
      this.form?.addEventListener('variant:change', (event) => this.update(event.detail?.variant), options);
      this.form?.addEventListener('change', () => this.update(), options);
      this.update();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    update(providedVariant) {
      if (!this.output) return;
      const form = document.getElementById(this.dataset.formId || '');
      const selectedId = form?.querySelector('[name="id"]')?.value;
      const variant = providedVariant || this.variants.find((item) => String(item.id) === String(selectedId || this.dataset.selectedVariant)) || this.variants[0];
      const allowTitle = this.variants.length <= 1 || variant?.title?.toLowerCase() === 'default title';
      const weight = window.NPCProductCore.netGrams(variant, this.dataset.productTitle, allowTitle);
      const price = Number(variant?.price || 0);
      if (this.hasAttribute('data-hide-unknown')) this.hidden = !(weight > 0 && price > 500);
      if (!(weight > 0) || !(price > 500)) {
        this.output.textContent = price > 500 ? 'Vikten behöver väljas' : 'Pris per kg kommer med priset';
        if (this.note) this.note.textContent = price > 500
          ? 'Förpackningsvikten kunde inte läsas automatiskt. Kontrollera variantnamnet.'
          : 'Vi räknar automatiskt på vald förpackning när priset är publicerat.';
        return;
      }
      const perKg = (price / 100) / (weight / 1000);
      this.output.textContent = `${perKg.toLocaleString('sv-SE', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'SEK',
        maximumFractionDigits: 2
      })} / kg`;
      if (this.note) this.note.textContent = `Beräknat på ${weight >= 1000 ? `${(weight / 1000).toLocaleString('sv-SE')} kg` : `${weight.toLocaleString('sv-SE')} g`} i vald förpackning.`;
    }
  }

  class NpcReorder extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-npc-reorder-button]');
      this.status = this.querySelector('[data-npc-reorder-status]');
      const data = this.querySelector('[data-npc-reorder-items]');
      try {
        this.items = JSON.parse(data?.textContent || '[]')
          .filter((item) => item.available && Number(item.id) > 0)
          .map((item) => ({ id: Number(item.id), quantity: Math.max(1, Number(item.quantity) || 1) }));
      } catch (_) {
        this.items = [];
      }
      if (!this.items.length && this.button) {
        this.button.disabled = true;
        this.button.textContent = 'Inga varor kan återbeställas';
      }
      this.button?.addEventListener('click', () => this.add());
    }

    async add() {
      if (!this.items.length || !this.button) return;
      this.button.disabled = true;
      this.button.textContent = 'Lägger i varukorgen…';
      if (this.status) this.status.textContent = '';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: this.items })
        });
        if (!response.ok) throw new Error('Cart add failed');
        track('npc_reorder_complete', { item_count: this.items.length });
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (_) {
        this.button.disabled = false;
        this.button.textContent = 'Försök återbeställa igen';
        if (this.status) this.status.textContent = 'Någon vara kan ha ändrats eller tagit slut. Öppna ordern och välj tillgängliga produkter.';
      }
    }
  }

  document.addEventListener('click', (event) => {
    const favorite = event.target.closest('[data-npc-favorite]');
    if (favorite) track('npc_favorite_click', { product_handle: favorite.dataset.npcFavorite || '' });

    const compare = event.target.closest('[data-npc-compare-product]');
    if (compare) track('npc_compare_click', { product_handle: compare.dataset.npcCompareProduct || '' });

    const productLink = event.target.closest('a[href*="/products/"]');
    if (productLink) {
      const handle = productLink.getAttribute('href')?.split('/products/')[1]?.split(/[?#]/)[0] || '';
      track('npc_product_click', {
        product_handle: handle,
        source: productLink.closest('.npc-match-card') ? 'nordic_match' : productLink.closest('.product-card') ? 'product_grid' : 'content'
      });
    }

    const clubLink = event.target.closest('a[href*="pet-club"], a[href*="view=member"]');
    if (clubLink) track('npc_club_click', { label: String(clubLink.textContent || '').trim().slice(0, 60) });
  }, { passive: true });

  document.addEventListener('submit', (event) => {
    if (event.target.matches('form[action*="/cart/add"], form[id*="product-form"]')) {
      const productSection = event.target.closest('[data-product-id], .npc-product-hero');
      track('npc_add_to_cart', { product_id: productSection?.dataset?.productId || '' });
    }
  }, true);

  if (!customElements.get('npc-unit-price')) customElements.define('npc-unit-price', NpcUnitPrice);
  if (!customElements.get('npc-reorder')) customElements.define('npc-reorder', NpcReorder);
})();
